export const BUSINESS = {
  name: "J11 Consulting LLC",
  shortName: "J11 Consulting",
  tagline: "EDUCATION • MENTORSHIP • FUNDING READINESS",
  descriptor: "Credit Education • Financial Literacy • Funding Readiness",
  phone: "(800) 505-1628",
  phoneHref: "tel:+18005051628",
  addressLine1: "195 Malabar Rd, Suite #3",
  addressLine2: "Palm Bay, FL 32907",
};

export const SMS_CONSENT_VERSION = "sms-consent-v2-education";

export const HELP_TOPICS = [
  "Understanding My Credit",
  "Building Better Credit Habits",
  "Business Credit Education",
  "Funding Readiness",
  "Financial Literacy",
  "Business Funding Education",
  "General Consultation",
];

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Programs", to: "/programs" },
  { label: "How It Works", to: "/#how-it-works" },
  { label: "Education", to: "/education" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const PROGRAMS = [
  {
    slug: "credit-education-mentorship",
    title: "Credit Education & Mentorship",
    description:
      "Designed for individuals who want to better understand their credit profile, the factors influencing it and responsible ways to build stronger financial habits.",
    topics: [
      "How credit reports and scores work",
      "Factors that may influence creditworthiness",
      "Responsible credit-building habits",
      "Payment history, utilization and inquiries",
    ],
  },
  {
    slug: "funding-readiness-mentorship",
    title: "Funding Readiness Mentorship",
    description:
      "Designed to help individuals and entrepreneurs understand what may influence funding decisions and prepare more effectively before applying.",
    topics: [
      "What lenders may evaluate",
      "Personal and business profile readiness",
      "Documentation and organization",
      "Application preparation",
    ],
  },
  {
    slug: "business-credit-education",
    title: "Business Credit Education",
    description:
      "Learn how business credit works, how lenders may evaluate businesses and how to establish stronger business financial foundations.",
    topics: [
      "Business credit fundamentals",
      "How personal and business credit interact",
      "Business financial organization",
      "Building business credit profiles",
    ],
  },
  {
    slug: "financial-literacy-coaching",
    title: "Financial Literacy Coaching",
    description:
      "Personalized education around credit, budgeting, financial organization, borrowing and responsible financial decision-making.",
    topics: [
      "Budgeting and financial organization",
      "Responsible borrowing",
      "Understanding financial products",
      "Long-term financial habits",
    ],
  },
];
